export enum LocationPointType {
    Private = 0,
    Shared = 1,
}
